import React,{useState,useEffect} from 'react'
import { HeartOutlined, StarOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { MenuUnfoldOutlined ,FieldTimeOutlined } from '@ant-design/icons'
import useGetApi from '../../services/useGetApi'
import { image_base_url } from '../../constants/Constant'
import { images } from '../../assests/imageExport/ImageExports'


const CourseGridCard = ({course}) => {
   const [isChatLoading, chatError, courseInfo, getCourseInfo] = useGetApi(
            `course/details/${course.id}`,
            [],
            true
    )
  
      const [rating,setRating] = useState(0)
  
      useEffect(() => {
          getCourseInfo(`course/details/${course?.id}`)
      },[course.id])
  
      useEffect(() => {
          if (courseInfo && courseInfo.reviews) {
            const totalReviews = courseInfo.reviews.length;
            if (totalReviews > 0) {
              const averageRating = courseInfo.reviews.reduce((sum, review) => sum + review.rating, 0) / totalReviews;
              setRating(averageRating);
            } else {
              setRating(0); 
            }
          }
      }, [courseInfo])

  return (
    <div className='grid_Card'>
      <Link to={`/course/${course.id}`} className='link'>
        <div>
            <img src={course?.thumbnail ? `${image_base_url}${course?.thumbnail}` : images.broken_course_image} alt='course_image'/>
        </div>

        <div className='middle'>
            <div>
                <p className='course_title'>{course?.title}</p>
                <p className='light_grey'>{rating} <StarOutlined /> ({courseInfo?.reviews?.length} Reviews) {course?.language || 'English'}
               
                </p>
            </div>

        </div>

        <p className='content light_grey'>{course?.description}</p>
        <div className='course_horizontal_line'></div>

        <div className='bottom'>
            <h3>₹0</h3>
            <p><MenuUnfoldOutlined /> {courseInfo?.sections?.length} Lessons <FieldTimeOutlined /> {course?.duration} mins</p>
        </div>
      </Link>
    </div>
  )
}

export default CourseGridCard
